<form
  [formGroup]="passwordForm"
  (ngSubmit)="passwordForm.valid && submitPasswordForm()"
  autocomplete="off"
>
  <ds-form-control-container
    [labelText]="'New Password'"
    [control]="passwordForm.controls['passwordInput']"
  >
    <show-hide>
      <input
        data-cy="resetPasswordInput"
        type="password"
        id="password"
        show-hide-input
        class="fill pad-right-60"
        formControlName="passwordInput"
        maxlength="15"
        autocomplete="off"
      />
    </show-hide>
    @if (errorText) {
      <small data-cy="newPasswordErrorText" class="block caption error margin-top-5">{{
        errorText
      }}</small>
    }
    <div class="pad-top-10">
      <div class="column twelve md-six">
        <ul class="criteria-list">
          @if (hasComponentUsernameInput) {
            <li
              [ngClass]="passwordForm.hasError('passwordContainsUserID') ? 'hasError' : 'isValid'"
              class="pseudo-icon"
            >
              Cannot contain user ID
            </li>
          }
          <li
            [ngClass]="passwordInput.hasError('invalidLength') ? 'hasError' : 'isValid'"
            class="pseudo-icon"
          >
            7-15 characters
          </li>
          <li
            [ngClass]="passwordInput.hasError('atLeastOneLetterError') ? 'hasError' : 'isValid'"
            class="pseudo-icon"
          >
            At least one letter
          </li>
        </ul>
      </div>
      <div class="column twelve md-six">
        <ul class="criteria-list">
          <li
            [ngClass]="passwordInput.hasError('atLeastOneNumberError') ? 'hasError' : 'isValid'"
            class="pseudo-icon"
          >
            At least one number
          </li>
          <li
            [ngClass]="passwordInput.hasError('invalidPasswordChars') ? 'hasError' : 'isValid'"
            class="pseudo-icon"
          >
            Can't include spaces or characters # ' * ; |
          </li>
        </ul>
      </div>
    </div>
  </ds-form-control-container>

  <button
    ds-button
    data-cy="resetPasswordConfirmButton"
    type="submit"
    class="float-right"
    [ngClass]="{ 'margin-top-10': !hasComponentUsernameInput }"
    [disabled]="!passwordForm.valid"
  >
    {{ confirmBtnText || 'Reset and Log In' }}
  </button>
</form>
